import React from "react";

const educationContent = [
  {
    year: "2016 - 2020",
    degree: "B.E MECHANICAL ENGINEERING",
    institute: "MAR EPHRAEM COLLEGE OF ENGINEERING AND TECHNOLOGY ELAVUVILA, KANYAKUMARI DIST TAMIL NADU, INDIA",
    details: `  CGPA: 7.02`,
  },
  {
    year: "2019",
    degree: "ANSYS WORKBENCH",
    institute: "CADD CENTRE TRAINING SERVICES MARTHANDAM, KANYAKUMARI DIST TAMIL NADU, INDIA",
    details: `Duaration: 40 Hours`,
  },
  {
    year: "2018",
    degree: "CATIA ",
    institute: "VIT TRAINING SERVICES MARTHANDAM, KANYAKUMARI DIST TAMIL NADU, INDIA",
    details: `Duaration: 45 Hours`,
  },
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
